(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.service('vvFaceDetection', function ($q, $http, vvLocalStorage) {
    var cacheLimit = 100;
    var dataLoaded = false;
    var faceDetected = [];
    var faceNotfound = [];

    var loadFaceDetected = function() {
      if (!dataLoaded) {
        faceDetected = vvLocalStorage.get('faceDetectedUrls') || [];
        faceNotfound = vvLocalStorage.get('faceNotfoundUrls') || [];
        dataLoaded = true;
      }
    };

    var callFaceApi = function(urls, limit) {
      var apiUrl = 'https://face-detector-cf.vonvon.me/api/faces/exists';
      var apiData = {urls:urls, limit: limit};
      console.log("apiData: ", apiData);
      return $http.post(apiUrl, angular.toJson(apiData));
    };

    var getFaceDetectedIndexes = function(urls, count) {
      if (!urls || urls.length == 0) {
        return $q.when(null);
      }

      loadFaceDetected();

      var detected = [];
      var notyet = [];
      var notyetUrls = [];

      urls.some(function(u, i) {
        if (u && faceDetected.indexOf(u) != -1) {
          detected.push(i);
        } else if (u && faceNotfound.indexOf(u) == -1 && notyetUrls.indexOf(u) == -1) {
          notyet.push(i);
          notyetUrls.push(u);
        }

        return (detected.length >= count && notyet.length == 0);
      });

      if (notyetUrls.length ==  0)
      return $q.when(detected);

      return callFaceApi(notyetUrls, Math.min(notyetUrls.length, count - notyet[0])).then(function(response) {
        response.data.forEach(function(d, i) {
          if (d) {
            detected.push(notyet[i]);
            if (faceDetected.indexOf(notyetUrls[i]) == -1)
            faceDetected.unshift(notyetUrls[i]);
          } else {
            if (faceNotfound.indexOf(notyetUrls[i]) == -1)
            faceNotfound.unshift(notyetUrls[i]);
          }
        });

        vvLocalStorage.set('faceDetectedUrls', faceDetected.slice(0, cacheLimit));
        vvLocalStorage.set('faceNotfoundUrls', faceNotfound.slice(0, cacheLimit));

        return detected;
      });
    };

    this.getFaceDetectedUrls = function(urls, count) {
      var detectedUrls = [];
      return getFaceDetectedIndexes(urls, count).then(function(indexes) {
        indexes.sort().forEach(function(i) {
          detectedUrls.push(urls[i]);
        });
        return detectedUrls.slice(0, count);
      });
    };

    this.getFaceDetectedFriends = function(friends, prop, count) {
      var friendsUrls = friends.map(function(item) {
        return eval('item.' + prop);
      });

      var detectedFriends = [];
      return getFaceDetectedIndexes(friendsUrls, count).then(function(indexes) {
        indexes.sort().forEach(function(i) {
          detectedFriends.push(friends[i]);
        });
        console.log("detectedFriends: ", detectedFriends);
        return detectedFriends.slice(0, count);
      });
    };

    this.promoteFaceDetectedFriends = function(friends, prop, count) {
      var friendsUrls = friends.map(function(item) {
        return eval('item.' + prop);
      });

      return getFaceDetectedIndexes(friendsUrls, count).then(function(indexes) {
        friends.forEach(function(friend, idx) {
          if (indexes.indexOf(idx) >= 0)
          friend.score += 500;
        });
        return friends.sort(comparator('-score')).slice(0, count);
      });
    };
  });
})(window, window.angular);
